<template>
    <a-row align="middle"
           justify="end">
        <a-col>
            <span class="n-c-3 n-f-4 n-block n-text-right">{{userInfo ? userInfo.username : '-'}}</span>
            <!-- <span class="n-c-2 n-f-2 n-block n-text-right">-</span> -->
        </a-col>
        <a-col>
            <a-avatar :src="require('@/assets/image/user.png')"
                      class="n-mlr-2" />
        </a-col>
        <a-col>
            <a-dropdown :trigger="['click']">
                <template #overlay>
                    <a-menu @click="clickUserMenu">
                        <a-menu-item key="logout">{{LAN.nui.common.logout}}</a-menu-item>
                    </a-menu>
                </template>
                <i class="n-icon n-icon-arrow-down n-icon-size-20 n-pointer"></i>
            </a-dropdown>
        </a-col>
    </a-row>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';

    import nui from '@/assets/script';

    export default {
        name: 'User',
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['userInfo'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                setTimeout(() => {
                    if (this.isLogin()) {
                        this.setUserInfo(this.getUserInfo())
                    }
                });
            },
            clickUserMenu () {
                this.removeUserInfo();
                window.location.href = this.LOGOUT_URL
            }
        }),
        components: {
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
</style>